import { CloseIcon } from '@sketchnote/icons';
import { Switch } from '@sketchnote/shared-components';
import { useBoardStore } from 'src/features/boards';

export const Customization = () => {
  const { showAssignee, showCommentsIcon } = useBoardStore((s) => s.calendarCustomize);
  const onToggleCalendarCustomize = useBoardStore((s) => s.toggleCalendarCustomize);
  const toggleShowAssignee = useBoardStore((s) => s.toggleShowAssignee);
  const toggleShowCommentsIcon = useBoardStore((s) => s.toggleShowCommentsIcon);
  return (
    <div className="m-24">
      <div className="flex justify-end">
        <button onClick={() => onToggleCalendarCustomize(false)}>
          <CloseIcon className="text-gray-500 text-xs" />
        </button>
      </div>
      <h3 className="mb-6">🔧️ Customize</h3>
      <p className="mb-24">Edit the way your board looks </p>
      <p className="mb-32">Customize calendar preview</p>
      <div>
        <div className="flex justify-between border-b p-10">
          <span>Assignee</span>
          <Switch onChange={(e) => toggleShowAssignee(!!e.target.checked)} checked={showAssignee} />
        </div>
        <div className="flex justify-between border-b p-10">
          <span>Comments icon </span>
          <Switch
            onChange={(e) => toggleShowCommentsIcon(!!e.target.checked)}
            checked={showCommentsIcon}
          />
        </div>
      </div>
    </div>
  );
};
